import AppSettings from "../AppSettings";
import gaskets from "./gasket/GasketInfo.json";
import { parseFraction } from "./gasket/dimensions";

function isGasket(part) {
  if (!part || !part.attributes) return false;
  return part.attributes.some(attr => attr.name === "Unit" && attr.value === "Pre-Molded");
}

function getGasket(partId) {
  partId = partId ? partId.toUpperCase(partId) : "";
  const gasket = gaskets.find(part => part.partId === partId);
  return gasket;
}

function customPartType(part) {
  if (part.custom) return part.custom;

  if (isGasket(part)) return "Gasket";
  return "";
}

function isCustomPart(part) {
  return !!customPartType(part);
}

function hasCustomParts(parts) {
  return parts.filter(part => isCustomPart(part)).length > 0;
}

function profileUrl(gasket) {
  return `${AppSettings.ImageService}/catalog/graphics%2fDrawings%5c${gasket.profile}.png`;
}

async function gasketPrice(partId, heightString, widthString, discountLevel) {
  const parsedHeight = parseFraction(heightString);
  const parsedWidth = parseFraction(widthString);
  if (!parsedHeight || !parsedWidth) return null;

  const payload = {
    ItemId: partId,
    CustomPart: "Gasket",
    GasketSpecs: {      
      Height: parsedHeight,      
      Width: parsedWidth
    }
  };

  try {
    const response = await fetch(AppSettings.ApiCustomPartPrice, {
      method: "POST",
      headers: { "Content-Type": "application/json", "ApiKey": process.env.REACT_APP_APIKEY },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      console.error("Pricing API failed", response.status);
      return null;
    }

    const data = await response.json();
    console.log("Pricing API response data:", data);
    // discountLevel determines which field to return:
    // List, Dealer, Wholesale

    switch (discountLevel) {
      case "Wholesale":
        return data.Wholesale;
      case "Dealer":
        return data.Dealer;
      default:
        return data.List;
    }
  } catch (err) {
    console.error("API exception:", err);
    return null;
  }
}


export { isGasket, getGasket, customPartType, isCustomPart, hasCustomParts, profileUrl, gasketPrice };
